export default __webpack_public_path__ + "static/media/genesis-egg.15ea19f3.png";